<template>
	<div id="app">
		<router-view :data="data" :exactData="exactData" :convertionsData="convertionsData"
			:applicationsData="applicationsData" :vCleanCodes="vCleanCodes" :vcleanExactCodes="vcleanExactCodes"
			:competitorCodes="competitorCodes" :codigosLimpadores="codigosLimpadores" :codigosConectores="codigosConectores"/>
	</div>
</template>

<script>
import api from './services/api';

const token = 'AIzaSyCAmftnS8u75-OYQMXU7c06P7Au77tcMA4';

const tabName = 'APLICAÇÕES';
const spreadsheetID = '1hMrO5DEHT2NM3_zPaRVzCMQA7lZtaVLlcs3rHmzlaVk';

const convertionsSheetTabName = 'Planilha10';
const convertionsSheetID = '13kT90A-sg-6KZFU_tcZ0G2KyQ-0rplmYqQgqUqiN6uA';

const applicationsSheeTabName = 'BASE DE DADOS';
const applicationsSheetID = '1SeDAacoLgCVbW-Ylj0zgq5o5Sbasd9UvPKAltmTJUzE';

const exactSheeTabName = 'Planilha1';
const exactSheetID = '1nE8mhuwqIG1EJQ8D7kufWHNsybXu3Ed7O1omcV1z5bM';

export default {
	name: 'app',
	data() {
		return {
			data: [],
			convertionsData: [],
			applicationsData: [],
			exactData: [],
			vCleanCodes: [],
			vcleanExactCodes: [],
			codigosLimpadores: [],
			codigosConectores: [],
			competitorCodes: []
		};
	},

	async beforeCreate() {

		// GET main data

		const mainDataResponse = await api.get(`${spreadsheetID}/values/${tabName}?key=${token}`);
		const mainDataValues = mainDataResponse.data.values;

		let brandItem, modelItem;

		for (let i = 2; i < mainDataValues.length; i++) {
			const mainDataValue = mainDataValues[i];

			if (!mainDataValue.length || !mainDataValue[0]) {
				brandItem.models.push(modelItem);
				this.data.push(brandItem);
				modelItem = null;
				brandItem = null;
				continue;
			}

			const brandName = mainDataValue[0].trim();

			if (!brandName) {
				continue;
			}

			if (!brandItem) {
				brandItem = { brand: brandName, models: [] };
			}

			const modelName = mainDataValue[1].trim();
			if (!modelItem) {
				modelItem = { model: modelName, items: [] };
			} else {
				if (modelItem.model !== modelName) {
					brandItem.models.push(modelItem);
					modelItem = { model: modelName, items: [] };
				}
			}

			const mainDataItem = {
				from: mainDataValue[2] && mainDataValue[2].trim(),
				to: mainDataValue[3] && mainDataValue[3].trim(),
				front: {},
				specific: {},
				back: {},
				frontPhoto: mainDataValue[16] && mainDataValue[16].trim(),
				backPhoto: mainDataValue[17] && mainDataValue[17].trim(),
				frontVideo: this.fixYouTubeEmbedURL(mainDataValue[18] && mainDataValue[18].trim()),
				backVideo: this.fixYouTubeEmbedURL(mainDataValue[19] && mainDataValue[19].trim()),
				automakerLogo: mainDataValue[20] && mainDataValue[20].trim(),
				frontDescription: mainDataValue[21] && mainDataValue[21].trim(),
				backDescription: mainDataValue[22] && mainDataValue[22].trim()
			};

			mainDataItem.front.hybridDriver = mainDataValue[4] && mainDataValue[4].trim(),
			mainDataItem.front.hybridPassenger = mainDataValue[5] && mainDataValue[5].trim(),
			mainDataItem.front.flexDriver = mainDataValue[6] && mainDataValue[6].trim(),
			mainDataItem.front.flexPassenger = mainDataValue[7] && mainDataValue[7].trim(),
			mainDataItem.front.ironDriver = mainDataValue[8] && mainDataValue[8].trim(),
			mainDataItem.front.ironPassenger = mainDataValue[9] && mainDataValue[9].trim(),

			mainDataItem.specific.pair = mainDataValue[10] && mainDataValue[10].trim(),
			mainDataItem.specific.driver = mainDataValue[11] && mainDataValue[11].trim(),
			mainDataItem.specific.passenger = mainDataValue[12] && mainDataValue[12].trim(),

			mainDataItem.back.carren = mainDataValue[13] && mainDataValue[13].trim(),
			mainDataItem.back.slim = mainDataValue[14] && mainDataValue[14].trim(),
			mainDataItem.back.iron = mainDataValue[15] && mainDataValue[15].trim(),

			modelItem.items.push(mainDataItem);
		}

		brandItem.models.push(modelItem);
		this.data.push(brandItem);

		// GET convertions data

		const convertionsResponse = await api.get(`${convertionsSheetID}/values/${convertionsSheetTabName}?key=${token}`);
		const convertionsValues = convertionsResponse.data.values;

		for (let i = 1; i < convertionsValues.length; i++) {
			const convertionValue = convertionsValues[i];

			const convertionItem = {
				brand: convertionValue[0] && convertionValue[0].trim(),
				competitorCode: convertionValue[1] && convertionValue[1].trim(),
				vcleanCode: convertionValue[2] && convertionValue[2].trim(),
				photo: convertionValue[3] && convertionValue[3].trim(),
				video: this.fixYouTubeEmbedURL(convertionValue[4] && convertionValue[4].trim()),
			};

			if (!this.competitorCodes.includes(convertionItem.competitorCode)) {
				this.competitorCodes.push(convertionItem.competitorCode);
			}
			this.convertionsData.push(convertionItem);
		}

		// GET applications data

		const applicationsDataResponse = await api.get(`${applicationsSheetID}/values/${applicationsSheeTabName}?key=${token}`);
		const applicationsDataValues = applicationsDataResponse.data.values;


		for (let i = 1; i < applicationsDataValues.length; i++) {

			const applicationsDataValue = applicationsDataValues[i];
			const vehicleCode = applicationsDataValue[1].trim();

			if (!this.vCleanCodes.includes(vehicleCode)) {
				this.vCleanCodes.push(vehicleCode);
			}

			let appData = this.applicationsData.find(item => item.vehicleCode === vehicleCode);

			const application = {
				model: applicationsDataValue[0] && applicationsDataValue[0].trim(),
			};

			if (!appData) {

				let vehiclePhotos;
				if (applicationsDataValue[8]) {
					vehiclePhotos = applicationsDataValue[8].split('|');
				}

				appData = {
					vehicleCode, applications: [],
					text: applicationsDataValue[2] && applicationsDataValue[2].trim(),
					connection: applicationsDataValue[3] && applicationsDataValue[3].trim(),
					number: applicationsDataValue[4] && applicationsDataValue[4].trim(),
					group: applicationsDataValue[5] && applicationsDataValue[5].trim(),
					photo: applicationsDataValue[6] && applicationsDataValue[6].trim(),
					video: this.fixYouTubeEmbedURL(applicationsDataValue[7] && applicationsDataValue[7].trim()),
					vehiclePhotos,
				};
				appData.applications.push(application);
				this.applicationsData.push(appData);

			} else {
				appData.applications.push(application);
				this.applicationsData = this.applicationsData.map(item => {
					return item.vehicleCode === appData.vehicleCode ? appData : item;
				});
			}
		}

		// GET exact data

		const exactDataResponse = await api.get(`${exactSheetID}/values/${exactSheeTabName}?key=${token}`);
		const exactDataValues = exactDataResponse.data.values;
		let exactData = [];
		for (let i = 2; i < exactDataValues.length; i++) {
			if (typeof exactDataValues[i] !== 'undefined' && exactDataValues[i].length > 0) {
				const exactDataValue = exactDataValues[i];

				exactData = {
					marca: exactDataValue[0] && exactDataValue[0].trim(),
					veiculo: exactDataValue[1] && exactDataValue[1].trim(),
					de: exactDataValue[2] && exactDataValue[2].trim(),
					ate: exactDataValue[3] && exactDataValue[3].trim(),
					codigoPolegadaMotorista: exactDataValue[4] && exactDataValue[4].trim(),
					tamanhoPolegadasMotorista: exactDataValue[5] && exactDataValue[5].trim(),
					codigoPolegadaCarona: exactDataValue[6] && exactDataValue[6].trim(),
					tamanhoPolegadasCarona: exactDataValue[7] && exactDataValue[7].trim(),
					codigoConectorMotCar: exactDataValue[8] && exactDataValue[8].trim(),
					codigoConector: exactDataValue[9] && exactDataValue[9].trim(),
					codigoCarenada: exactDataValue[10] && exactDataValue[10].trim(),
					tamanhoPolegadasCarenada: exactDataValue[11] && exactDataValue[11].trim(),
					codigoSlim: exactDataValue[12] && exactDataValue[12].trim(),
					tamanhoPolegadasSlim: exactDataValue[13] && exactDataValue[13].trim(),
					codigoConectorTraseiro: exactDataValue[14] && exactDataValue[14].trim(),
					conectorTraseiro: exactDataValue[15] && exactDataValue[15].trim(),
					descricaoLamina: exactDataValue[16] && exactDataValue[16].trim(),
					descricaoVeiculo: exactDataValue[17] && exactDataValue[17].trim(),
					videoAplicacaoDianteira: this.fixYouTubeEmbedURL(exactDataValue[18] && exactDataValue[18].trim()),
					imagemMotoristaDianteira: exactDataValue[19] && exactDataValue[19].trim(),
					imagemCaronaDianteira: exactDataValue[20] && exactDataValue[20].trim(),
					videoAplicacaoTraseira: this.fixYouTubeEmbedURL(exactDataValue[21] && exactDataValue[21].trim()),
					imagemMotoristaTraseira: exactDataValue[22] && exactDataValue[22].trim(),
					imagemCaronaTraseira: exactDataValue[23] && exactDataValue[23].trim(),
					logoMontadora: exactDataValue[24] && exactDataValue[24].trim(),
					descricaoGeral: exactDataValue[25] && exactDataValue[25].trim(),
					grupoGeral: exactDataValue[26] && exactDataValue[26].trim(),
					imagemLimpadorDianteiro: exactDataValue[27] && exactDataValue[27].trim(),
					imagemConectorDianteiro: exactDataValue[28] && exactDataValue[28].trim(),
					videoMontagemDianteiro: this.fixYouTubeEmbedURL(exactDataValue[29] && exactDataValue[29].trim()),
					imagemLimpadorTraseiro: exactDataValue[30] && exactDataValue[30].trim(),
					imagemConectorTraseiro: exactDataValue[31] && exactDataValue[31].trim(),
					videoMontagemTraseiro: this.fixYouTubeEmbedURL(exactDataValue[32] && exactDataValue[32].trim()),
				};

				if (exactData.ate == '>') {
					exactData.ate = 'EM DIANTE';
				}else{
					exactData.ate = `ATÉ ${exactData.ate}`;
				}
				this.exactData.push(exactData);

				if (!this.vcleanExactCodes.includes(exactData.codigoPolegadaMotorista)) {
					this.vcleanExactCodes.push(exactData.codigoPolegadaMotorista);
					// let fotosLimpador = [];
					// if(exactData.imagemMotoristaDianteira){
					// 	fotosLimpador.push(exactData.imagemMotoristaDianteira);
					// }
					// if(exactData.imagemCaronaDianteira){
					// 	fotosLimpador.push(exactData.imagemCaronaDianteira);
					// }
					this.codigosLimpadores.push({ 
						codigo: exactData.codigoPolegadaMotorista,
						tamanho: exactData.tamanhoPolegadasMotorista,
						grupo: exactData.grupoGeral,
						videoLimpador: exactData.videoMontagemDianteiro, 
						imagemMotoristaDianteira: exactData.imagemMotoristaDianteira,
						imagemCaronaDianteira: exactData.imagemCaronaDianteira,
						descricao: exactData.descricaoGeral,
						exactVeiculoConector: [],
						fotosLimpador: [exactData.imagemLimpadorDianteiro]
					});
				}

				if (!this.vcleanExactCodes.includes(exactData.codigoPolegadaCarona)) {
					this.vcleanExactCodes.push(exactData.codigoPolegadaCarona);
					// let fotosLimpador = [];
					// if(exactData.imagemMotoristaDianteira){
					// 	fotosLimpador.push(exactData.imagemMotoristaDianteira);
					// }
					// if(exactData.imagemCaronaDianteira){
					// 	fotosLimpador.push(exactData.imagemCaronaDianteira);
					// }
					this.codigosLimpadores.push({ 
						codigo: exactData.codigoPolegadaCarona,
						tamanho: exactData.tamanhoPolegadasCarona,
						grupo: exactData.grupoGeral,
						videoLimpador: exactData.videoMontagemDianteiro, 
						imagemMotoristaDianteira: exactData.imagemMotoristaDianteira,
						imagemCaronaDianteira: exactData.imagemCaronaDianteira,
						descricao: exactData.descricaoGeral,
						exactVeiculoConector: [],
						fotosLimpador: [exactData.imagemLimpadorDianteiro]
					});
				}

				if (!this.vcleanExactCodes.includes(exactData.codigoConectorMotCar)) {
					this.vcleanExactCodes.push(exactData.codigoConectorMotCar);
					// let fotosLimpador = [];
					// if(exactData.imagemMotoristaDianteira){
					// 	fotosLimpador.push(exactData.imagemMotoristaDianteira);
					// }
					// if(exactData.imagemCaronaDianteira){
					// 	fotosLimpador.push(exactData.imagemCaronaDianteira);
					// }
					this.codigosConectores.push({
						codigo: exactData.codigoConectorMotCar,
						conector: exactData.codigoConector,
						grupo: exactData.grupoGeral,
						videoLimpador: exactData.videoMontagemDianteiro, 
						imagemMotoristaDianteira: exactData.imagemMotoristaDianteira,
						imagemCaronaDianteira: exactData.imagemCaronaDianteira,
						descricao: exactData.descricaoGeral,
						exactLimpadorPolegada: [],
						fotosLimpador: [exactData.imagemConectorDianteiro]
					});
				}

				if (!this.vcleanExactCodes.includes(exactData.codigoCarenada)) {
					this.vcleanExactCodes.push(exactData.codigoCarenada);
					// let fotosLimpador = [];
					// if(exactData.imagemMotoristaDianteira){
					// 	fotosLimpador.push(exactData.imagemMotoristaDianteira);
					// }
					// if(exactData.imagemCaronaDianteira){
					// 	fotosLimpador.push(exactData.imagemCaronaDianteira);
					// }
					this.codigosLimpadores.push({ 
						codigo: exactData.codigoCarenada,
						tamanho: exactData.tamanhoPolegadasCarenada,
						grupo: exactData.grupoGeral,
						videoLimpador: exactData.videoMontagemTraseiro, 
						imagemMotoristaDianteira: exactData.imagemMotoristaDianteira,
						imagemCaronaDianteira: exactData.imagemCaronaDianteira,
						descricao: exactData.descricaoGeral,
						exactVeiculoConector: [],
						fotosLimpador: [exactData.imagemLimpadorTraseiro]
					});
				}

				if (!this.vcleanExactCodes.includes(exactData.codigoSlim)) {
					this.vcleanExactCodes.push(exactData.codigoSlim);
					// let fotosLimpador = [];
					// if(exactData.imagemMotoristaDianteira){
					// 	fotosLimpador.push(exactData.imagemMotoristaDianteira);
					// }
					// if(exactData.imagemCaronaDianteira){
					// 	fotosLimpador.push(exactData.imagemCaronaDianteira);
					// }
					this.codigosLimpadores.push({ 
						codigo: exactData.codigoSlim,
						tamanho: exactData.tamanhoPolegadasSlim,
						grupo: exactData.grupoGeral,
						videoLimpador: exactData.videoMontagemTraseiro, 
						imagemMotoristaDianteira: exactData.imagemMotoristaDianteira,
						imagemCaronaDianteira: exactData.imagemCaronaDianteira,
						descricao: exactData.descricaoGeral,
						exactVeiculoConector: [],
						fotosLimpador: [exactData.imagemLimpadorTraseiro]
					});
				}

				if (!this.vcleanExactCodes.includes(exactData.codigoConectorTraseiro)) {
					this.vcleanExactCodes.push(exactData.codigoConectorTraseiro);
					// let fotosLimpador = [];
					// if(exactData.imagemMotoristaDianteira){
					// 	fotosLimpador.push(exactData.imagemMotoristaDianteira);
					// }
					// if(exactData.imagemCaronaDianteira){
					// 	fotosLimpador.push(exactData.imagemCaronaDianteira);
					// }
					this.codigosConectores.push({
						codigo: exactData.codigoConectorTraseiro,
						conector: exactData.conectorTraseiro,
						grupo: exactData.grupoGeral,
						videoLimpador: exactData.videoMontagemTraseiro, 
						imagemMotoristaDianteira: exactData.imagemMotoristaDianteira,
						imagemCaronaDianteira: exactData.imagemCaronaDianteira,
						descricao: exactData.descricaoGeral,
						exactLimpadorPolegada: [],
						fotosLimpador: [exactData.imagemConectorTraseiro]
					});
				}

				// veiculoExact = `${exactData.marca} ${exactData.veiculo} ${exactData.de} ${exactData.ate}`
				
			}
		}

		await this.codigosLimpadores.forEach(element => {
			let exactVeiculosListLimpadores = this.exactData.filter((row) => 
				row.codigoPolegadaMotorista == element.codigo || row.codigoPolegadaCarona == element.codigo ||
				row.codigoCarenada == element.codigo || row.codigoSlim == element.codigo
			);
			exactVeiculosListLimpadores.forEach(row => {
				if (row.codigoPolegadaMotorista == element.codigo || row.codigoPolegadaCarona == element.codigo) {
					element.exactVeiculoConector.push({
						veiculo: `${row.marca} ${row.veiculo} ${row.de} ${row.ate}`,
						conector: row.codigoConectorMotCar,
					})
				}else{
					element.exactVeiculoConector.push({
						veiculo: `${row.marca} ${row.veiculo} ${row.de} ${row.ate}`,
						conector: row.codigoConectorTraseiro,
					})
				}
			});
		});

		await this.codigosConectores.forEach(element => {

			let exactVeiculosListConectores = this.exactData.filter((row) => 
				row.codigoConectorMotCar == element.codigo ||
				row.codigoConectorTraseiro == element.codigo
			);

			exactVeiculosListConectores.forEach(row => {
				if(row.codigoConectorMotCar == element.codigo){
					element.exactLimpadorPolegada.push({
						veiculo: `${row.marca} ${row.veiculo} ${row.de} ${row.ate}`,
						tamanho: row.tamanhoPolegadasMotorista,
					});
					element.exactLimpadorPolegada.push({
						veiculo: `${row.marca} ${row.veiculo} ${row.de} ${row.ate}`,
						tamanho: row.tamanhoPolegadasCarona,
					});
				}else{
					element.exactLimpadorPolegada.push({
						veiculo: `${row.marca} ${row.veiculo} ${row.de} ${row.ate}`,
						tamanho: row.tamanhoPolegadasCarenada,
					});
					element.exactLimpadorPolegada.push({
						veiculo: `${row.marca} ${row.veiculo} ${row.de} ${row.ate}`,
						tamanho: row.tamanhoPolegadasSlim,
					});
				}
			});
		});
	},
	methods: {
		fixYouTubeEmbedURL(url) {
			if (!url) {
				return url;
			}

			if (url.includes('https://www.youtube.com/embed')) {
				return url;
			}

			let videoID = url.substring(url.indexOf('?v=') + 3);
			if (videoID.includes('&')) {
				videoID = videoID.substring(0, videoID.indexOf('&'));
			}

			return `https://www.youtube.com/embed/${videoID}`;
		}
	}
};
</script>

<style>
* {
	color: #004f64 !important;
}

#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #004f64;
	padding: 30px;
}

.btn-light {
	color: #f8f9fa !important;
	border-color: #004e64 !important;
	background-color: #004e64 !important;
}

.btn-light:hover {}
</style>
